var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 232,
    viewBox: "0 0 221 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.138 97.4433V220C199.138 222.209 197.347 224 195.138 224H146.921M199.138 97.4433L175.913 77.945L113.75 25.7583C112.273 24.5183 110.122 24.5088 108.634 25.7356L21.6627 97.4433M199.138 97.4433H208.009C211.744 97.4433 213.441 92.7793 210.58 90.379L199.138 80.7791M21.6627 97.4433V220C21.6627 222.209 23.4536 224 25.6627 224H73.3997M21.6627 97.4433H12.1789C8.42281 97.4433 6.73782 92.7342 9.6413 90.3513L108.636 9.10576C110.123 7.88475 112.27 7.89637 113.744 9.13343L175.913 61.2929M73.3997 224V155.613C73.3997 153.404 75.1906 151.613 77.3997 151.613H142.921C145.13 151.613 146.921 153.404 146.921 155.613V224M73.3997 224H146.921M175.913 61.2929V27.6186C175.913 25.4094 177.703 23.6186 179.913 23.6186H195.138C197.347 23.6186 199.138 25.4094 199.138 27.6186V80.7791M175.913 61.2929L199.138 80.7791M129.466 77.6289H91.8156C89.6064 77.6289 87.8156 79.4197 87.8156 81.6289V114.376C87.8156 116.585 89.6064 118.376 91.8156 118.376H129.466C131.675 118.376 133.466 116.585 133.466 114.376V81.6289C133.466 79.4197 131.675 77.6289 129.466 77.6289Z",
    stroke: "black",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2508 189.189L111.572 166.896C112.906 165.432 115.328 166.59 115.027 168.547L113.222 180.27C113.031 181.515 114.025 182.626 115.284 182.572L126.162 182.107C127.944 182.031 128.927 184.15 127.718 185.461L106.827 208.122C105.416 209.652 102.897 208.277 103.421 206.263L106.481 194.503C106.82 193.199 105.799 191.939 104.453 192.001L92.8205 192.534C91.0409 192.616 90.0507 190.506 91.2508 189.189Z",
    fill: "url(#paint0_linear_109_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_83",
    x1: 113.394,
    y1: 166.29,
    x2: 88.5332,
    y2: 180.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5ED4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.8d1d584c807fa2e862a2101b50ef3ff1.svg";
export { ForwardRef as ReactComponent };